var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-pagamento-lote-selector',{staticClass:"no-select",attrs:{"status":_vm.pagamento.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }